export default "__VITE_ASSET__DPS7xZSS__"